import type { ReactElement, ReactNode } from 'react'

import { Flex } from '@twisto/components/atoms/flex'
import { MessageBox } from '@twisto/components/molecules/message-box'
import { WarningOutlineIcon } from '@twisto/icons'

import * as styles from './validation-box.styles'

type Props = {
  children: ReactNode
  message: ReactElement | string
  isVisible?: boolean
  className?: string
}

export const ValidationBox = ({
  children,
  message,
  isVisible = false,
  className,
  ...rest
}: Props) => {
  if (isVisible) {
    return (
      <Flex
        className={className}
        css={styles.container}
        data-testid="validation-box"
        direction="column"
        {...rest}
      >
        <div css={styles.content}>{children}</div>
        <MessageBox color="warning" icon={WarningOutlineIcon}>
          {message}
        </MessageBox>
      </Flex>
    )
  }

  return <>{children}</>
}
